import React, { useState } from "react";
import {Col, Row} from "antd";
import StudyList from "@/pages/Product/Study/StudyList";
import Bg from "@/assets/images/product/practice/bg.jpeg";
import IconTeam from "@/assets/images/product/study/icon-team.png";
import LeagueBg01 from "@/assets/images/product/practice/league-bg01.jpg";
import LeagueBg02 from "@/assets/images/product/practice/league-bg02.jpg";
import LeagueBg03 from "@/assets/images/product/practice/league-bg03.jpg";
import LeagueBg04 from "@/assets/images/product/practice/league-bg04.jpg";
import LeagueBg05 from "@/assets/images/product/practice/league-bg05.jpg";
import LeagueBg06 from "@/assets/images/product/practice/league-bg06.jpg";
import LeagueBg07 from "@/assets/images/product/practice/league-bg07.jpg";
import LeagueBg08 from "@/assets/images/product/practice/league-bg08.jpg";
import LeagueBg09 from "@/assets/images/product/practice/league-bg09.jpg";

import IconWater from "@/assets/images/product/study/icon-water.png";
import IconArt from "@/assets/images/product/study/icon-art.png";
import IconTime from "@/assets/images/product/study/icon-time.png";
import IconUser from "@/assets/images/product/study/icon-user.png";
import IconFlag from "@/assets/images/product/study/icon-flag.png";

const Practice: React.FC = () => {
  const [data, setData] = useState([{
    title: '红色团建',
    desc: '课程产品体系',
    pic: IconTeam,
    contents: [{
      pic: LeagueBg01,
      title: '强国之梦',
      desc: [{
        name: '活动形式',
        content: '依托红色地标场地与智能线上闯关系统，分组领取强国主题任务卡，融合党史答题、实景线索探索、团队协作挑战，分段完成科技、国防、文化、生态多主题闯关打卡，全程线上实时计分。'
      },{
        name: '活动目标',
        content: '紧扣强国建设时代主题，把理论学习转化实景体验，在协作闯关里深化党员使命认知，强化跨部门协同能力，以沉浸式研学筑牢实干奋进的思想根基。'
      }]
    },{
      pic: LeagueBg02,
      title: '红色趣味运动会',
      desc: [{
        name: '活动形式',
        content: '以长征历史典故为原型，设置飞夺泸定桥、火线担架、穿越草地、物资运输等趣味竞技项目，全员分组 PK，分项累计积分，开展红歌互动、队伍风采展示。'
      },{
        name: '活动目标',
        content: '复刻长征艰苦历程，用趣味运动传承红色奋斗精神，强健职工体魄，丰富党日活动载体，提升支部集体凝聚力与集体荣誉感。'
      }]
    },{
      pic: LeagueBg03,
      title: '建党伟业',
      desc: [{
        name: '活动形式',
        content: '各小组自主完成战队命名、口号创编、队形设计，依次开展红色知识比拼、任务攻坚，根据提示信息获取到建党全部内容，最终找到汇合点对接暗号完成任务。'
      },{
        name: '活动目标',
        content: '立足打造先锋党员队伍，凝聚团队向心力，引导党员立足本职破难题，强化先锋模范意识，推动党建工作与业务工作深度融合落地。'
      }]
    }]
  },{
    title: '红色演绎',
    desc: '课程产品体系',
    pic: IconWater,
    contents: [{
      pic: LeagueBg04,
      title: '红色实景剧本杀・北平以北',
      desc: [{
        name: '活动形式',
        content: '依托室内活动空间布置抗战敌后场景，全员分配游击队员、地下联络员、伪政权人员、爱国百姓等人物剧本，凭借线索搜证、秘密接头、阵营辩驳，完成情报护送、突围掩护等主线任务，还原平北敌后抗战往事。'
      },{
        name: '活动目标',
        content: '依托平北抗战真实历史改编剧本，沉浸式还原敌后游击艰苦岁月，使党员切身感受敌后军民浴血奋战的爱国风骨，强化忧患意识与攻坚克难的责任担当。'
      }]
    },{
      pic: LeagueBg05,
      title: '红色实景剧本杀・黎明',
      desc: [{
        name: '活动形式',
        content: '以解放前夕北平地下谍战为故事蓝本，参与者分别饰演地下党员、保密局特务、爱国知识分子、商行老板等角色，依靠现场搜证、私下密谈、公投推理，破解密电线索、守护关键情报、挫败敌人破坏计划。'
      },{
        name: '活动目标',
        content: '复刻建国前夕隐蔽战线斗争史实，让党员化身潜伏革命者体悟险境之中的信仰坚守，深刻理解胜利来之不易，筑牢不忘初心、坚守使命的思想根基。'
      }]
    },{
      pic: LeagueBg06,
      title: '红色剧本围读',
      desc: [{
        name: '活动形式',
        content: '选取《把一切献给党》《红星之下》等9大经典原文改编剧本，参与者分组认领英雄、战士、群众等角色，围坐分段诵读台词，穿插分段即兴片段演绎，党史讲师穿插讲解原型人物真实历史事迹。'
      },{
        name: '活动目标',
        content: '依托革命纪实原著内容沉浸式品读先辈事迹，在台词诵读与实景演绎中感悟革命先辈舍身报国、向党奉献的赤诚初心，创新室内党课学习形式，厚植党员忠诚爱党、履职尽责的理想信念。'
      }]
    }]
  },{
    title: '特色主题',
    desc: '课程产品体系',
    pic: IconArt,
    contents: [{
      pic: LeagueBg07,
      title: '红色手工体验',
      desc: [{
        name: '活动形式',
        content: '在手作教室配备布艺、木板、颜料、原料等物料，由专业讲师现场教学，参与者亲手制作手绘党旗、红军摆件、长征主题版画等红色手工艺品。'
      },{
        name: '活动目标',
        content: '以指尖手作回望峥嵘党史，活化红色文化学习形式，留存红色纪念作品，厚植党员爱国初心，充实党建阵地陈列素材。'
      }]
    },{
      pic: LeagueBg08,
      title: '主题读书分享',
      desc: [{
        name: '活动形式',
        content: '精选红色党史、伟人著作类书目，全员集中研读，分小组围绕书本内容结合岗位交流研讨，选派代表上台分享感悟，撰写个人读书践行心得。'
      },{
        name: '活动目标',
        content: '营造书香党建氛围，夯实党员理论素养，从经典著作中汲取工作方法，实现以学促干、以思践行，助力支部常态化理论建设。'
      }]
    },{
      pic: LeagueBg09,
      title: '红色户外骑行',
      desc: [{
        name: '活动形式',
        content: '沿本地红色旧址规划骑行线路，配备骑行车辆与讲解素材，全员编队低碳骑行，途经革命点位驻足参观、党史打卡、红色问答互动。'
      },{
        name: '活动目标',
        content: '车轮丈量红色热土，践行绿色低碳理念，在行走研学中重温本土革命历史，创新户外党课形式，锤炼党员初心使命。'
      }]
    }]
  }])

  const [dataVisit, setDataVisit] = useState([{
    title: '走进贵州村超・ IP 落地',
    tips: '乡村振兴',
    desc: '学习零成本草根赛事裂变亿级流量，低成本打造县域爆款 IP 实操路径贵州省人民政府\n' +
      '掌握「村超 + 餐饮 + 民宿 + 非遗文创」全链路变现，实现流量→留量→产业增收完整打法',
    tag: [{
      pic: IconTime,
      name: '课程时长：',
      content: '1天'
    }, {
      pic: IconUser,
      name: '学员对象：',
      content: '县域政企管理者、文旅操盘手、乡村项目创业者、党建品牌负责人'
    }, {
      pic: IconFlag,
      name: '授课形式：',
      content: '展馆参观 + 产业园实地走访 + 核心操盘手闭门座谈 + 现场观赛 + 分组研讨'
    }],
    base: {
      title01: '课程介绍',
      content01: '贵州“村超”，是诞生于资源禀赋有限县域的时代奇迹。它绝非一场普通的乡村足球赛事，而是将“政府引领 + 群众参与 + 情感共鸣 + 新媒体裂变”深度融合的标杆样本，生动诠释了中国式乡村振兴 3.0 的破局路径。它向我们展示了，如何用最低的成本撬动亿级流量，如何将无形的文化资源转化为真金白银的产业价值。',
      title02: '参访特点',
      desc02: [{
        name: '[榕江村超操盘团队]：',
        text: '从政策制定者和地方发展操盘手的视角，解读“村超” 背后的政府支持逻辑与县域发展战略'
      }, {
        name: '[村超策划团队]：',
        text: '从0 到 1、从 1 到 100，全面复盘 “村超” 的策划思路、战略定位、破圈之道及可持续发展之路'
      }, {
        name: '[村超IP 运营官]：',
        text: '分享“村超” IP 的日常运营、新媒体矩阵管理、流量转化与持续创新的具体操作手法'
      }],
    }
  },{
    title: '走进菜百・老字号黄金企业转型',
    tips: '数智化转型',
    desc: '老牌国企从传统柜台到博物馆式门店的升级路径，吃透「馆店一体」创新商业模式\n' +
      '国潮 IP 联名、直播电商、多子品牌分层运营，破解传统黄金品牌老龄化困局',
    tag: [{
      pic: IconTime,
      name: '课程时长：',
      content: '0.5天'
    }, {
      pic: IconUser,
      name: '学员对象：',
      content: '党委书记、党务负责人、传统商贸中高管、品牌数字化负责人'
    }, {
      pic: IconFlag,
      name: '授课形式：',
      content: '四层场馆实地巡馆 + 数字化创新工作室体验 + 高管专题分享 + 互动答疑'
    }],
    base: {
      title01: '课程介绍',
      content01: '菜百被誉为中国黄金第一家，1956 年创立的国有老字号，国内黄金零售头部标杆，年营收稳居行业前列，首创黄金珠宝博物馆 + 线下卖场一体化经营模式。面对传统珠宝门店库存高、获客难、体验弱痛点，菜百率先落地全链路数字化改造，自研多款行业专利智能设备，完成线下卖场全场景智能化升级。本次参访走进菜百总店，深度拆解老字号守正创新、数智化降本增效、全渠道营销落地实战经验。',
      title02: '参访特点',
      desc02: [{
        name: '[四层全业态场馆]：',
        text: '一层黄金文创区、二层钻饰展区、三层数字化创新实验室、四层虫珀科普 + 直播基地，完整参观全场景门店布局'
      }, {
        name: '[数智化全模块]：',
        text: '智慧门店硬件体验、供应链数字化、私域会员运营、直播间运营四大落地案例'
      },{
        name: '[企业高管分享]：',
        text: '菜百数字化事业部负责人、人力高管，详解转型踩坑经验与人才梯队搭建方案'
      }],
    }
  },{
    title: '走进协鑫・双碳新能源企业转型升级',
    tips: '党建标杆',
    desc: '学习集团人才搭建、党建阵地建设、红色基因传承、股权激励、产融结合成熟管理模式\n' +
      '复盘协鑫三次战略迭代，从重资产制造向新材料、风光储氢全产业链转型路径',
    tag: [{
      pic: IconTime,
      name: '课程时长：',
      content: '0.5-1 天'
    }, {
      pic: IconUser,
      name: '学员对象：',
      content: '制造业企业家、新能源从业者、集团中高层管理者、党支部书记、党务负责人'
    }, {
      pic: IconFlag,
      name: '授课形式：',
      content: '未来能源馆参观 + 智能制造车间走访 + 高管主题授课 + 圆桌互动交流'
    }],
    base: {
      title01: '课程介绍',
      content01: '协鑫集团深耕绿色能源 32 年，全球新能源 500 强头部企业、国内民营新能源龙头，手握 4 家上市公司，布局光伏、储能、硅基新材料、集成电路材料多赛道，依托双碳政策完成从传统热电到全球综合能源服务商蜕变，打造「数字协鑫、科技协鑫、绿色协鑫」三大发展体系，靠技术创新实现降碳增效、负债率优化。当下众多制造企业面临转型迷茫、碳中和落地无方向、组织管理低效难题，本次走进苏州协鑫总部，实地学习头部新能源企业战略布局、智能制造与组织变革实战经验。',
      title02: '参访特点',
      desc02: [{
        name: '[两大核心园区]：',
        text: '协鑫未来能源科普馆 + 光伏智能制造生产车间，全链条观摩新能源从研发到量产全过程'
      }, {
        name: '[四大课题]：',
        text: '企业战略转型、智能制造数字化、双碳产业落地、党建品牌建设四大交流专题'
      }, {
        name: '[集团资深高管]：',
        text: '集团战略 / 人力 / 研发线高管，结合 30 余年实战案例深度拆解企业变革经验'
      }]
    }
  }])

  return (
    <main className='warp-consult warp-visit wrap-study header-top'>
      <div className='warp-consult-header'>
        <img src={Bg} alt=""/>
      </div>
      <div className='warp-league-list'>
        <div className='warp-league-list-content'>
          <div className='home-page'>
            <>
              <div className='wrap-title' style={{marginBottom: '60px'}}>红擎活动</div>
              {
                data.map((item, index) => (
                  <div>
                    <div className='wrap-header' key='header' style={{marginTop: `${ index ? '87px' : ''}`}}>
                      <img src={item.pic} alt=""/>
                      <div>
                        <div className='desc'>{item.desc}</div>
                        <div className='title'>{item.title}</div>
                      </div>
                    </div>
                    {
                      item.contents.map(c => (
                        <div className='wrap-content' key='content'>
                          <Row className='wrap-content-block'>
                            <Col style={{marginRight: '40px'}}>
                              <img src={c.pic} alt=""/>
                            </Col>
                            <Col md={15} className='wrap-content-block-right'>
                              <div className='content-title'>{c.title}</div>
                              {
                                c.desc.map(d => (
                                  <div className='content-desc'>
                                    <div className='content-desc-t'>{d.name}</div>
                                    <div className='content-desc-c'>{d.content}</div>
                                  </div>
                                ))
                              }
                            </Col>
                          </Row>
                        </div>
                      ))
                    }
                  </div>
                ))
              }
            </>
            <>
              <div className='wrap-title' style={{marginTop: '80px'}}>红擎研学</div>
              <StudyList />
            </>
            <>
              <div className='wrap-title'>红擎参访</div>
              <div className='warp-visit-content'>
                <div className='warp-visit-content-items'>
                  {
                    dataVisit.map(item => (
                      <div className='content-item'>
                        <div className='content-item-header'>
                          <div className='visit-header'>
                            <div className='visit-header-title'>{item.title}</div>
                            <div className='visit-header-tag flex-center'>{item.tips}</div>
                          </div>
                        </div>
                        <div className='content-item-tag'>
                          {
                            item.tag.map(t => (
                              <div className='tag-block'>
                                <img src={t.pic} alt=""/>
                                <span className='dur'>{t.name}</span>
                                <span className='day'>{t.content}</span>
                              </div>
                            ))
                          }
                        </div>
                        <div className='content-item-desc p-pre-wrap'>
                          {item.desc}
                        </div>
                        <div className='content-item-line'></div>
                        <div className='content-item-block'>
                          <div className='b-title'>
                            {item.base.title01}
                          </div>
                          <div className='b-content p-pre-wrap'>
                            {item.base.content01}
                          </div>
                          <div className='b-title'>
                            {item.base.title02}
                          </div>
                          <div className='wrap-b-desc'>
                            {
                              item.base.desc02.map(d => (
                                <div className='b-desc'>
                                  <div className='dot'></div>
                                  <div className='text'>
                                    <span>{d.name}</span>{d.text}
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Practice